/*
 * @Author: your name
 * @Date: 2021-09-23 10:39:56
 * @LastEditTime: 2021-09-24 15:23:57
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \鲁南项目\src\modules\account\api.js
 */
export const api = {
  company: {
    batchFileload: '/common/file/batchFileload.json', // 上传图片
    deleteCustomCompany: '/bms/customCompany/daleteCustomCompany.json', // 删除公司信息
    queryCustomCompany: '/bms/customCompany/selectCustomCompanyListPage.json', // 分页查询公司信息
    updateCustomCompany: '/bms/customCompany/updateCustomCompany.json', // 修改公司信息
    addCustomCompany: '/bms/customCompany/addCustomCompany.json', // 新增公司信息
  },
}